<template lang="pug">
.fillblank
  Form.question-stem(:model="question" label-position="right")
      FormItem(label="段落内容及问题设置")
        //- span(style="float:left;width:20px; height:32px; line-height:32px;font-size:14px") 3.
        //- Input(placeholder="题目内容",v-model='question.stem')
      iDelModel(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
      div
        div(v-for="(item,index) in question.extend" :key="item.key")
          Row
            Col(span="18")
              FormItem(:label='`段落${index + 1}`' :label-width="80")
                  Input.steminp(placeholder="请输入段落标题" v-model="item.title" :maxlength="20")
            Col(span="6")
              Button(v-if="index != 0" type="error" shape="circle" icon="md-close" @click="handleDelPar(index)")
          FormItem(label='' :label-width="80")
            quillEditor(v-model="item.editorContent" ref="myQuillEditor" :options="editorOption")
      FormItem(label='' :label-width="80")
        Button(type="primary" icon="md-add" ghost @click="handleAddPar") 添加段落
      FormItem(label='' :label-width="80")
        Input.steminp(v-model="question.stem" placeholder="题目内容" :maxlength="50")
      div
        div(v-for="(item,index) in question.metas" :key="item.key")
          Row
            Col(span="3")
              FormItem(:label='`问题${index + 1}`' :label-width="80")
            Col(span="6")
              Button(v-if="index != 0" type="error" shape="circle" icon="md-close" @click="handleDelQuestion(index)")
          FormItem(label='' :label-width="80")
            Row
              Col(span="12")
                FormItem(label='段落位置' )
                  Select(placeholder="请选择" v-model='item.position')
                    Option(v-for="(item,index) in question.extend" :value="`段落${index+1}`" :key="item.key") {{ `段落${index+1}` }}
              Col(span="12")
                FormItem(label='存在问题' )
                  Select(placeholder="请选择" v-model='item.question')
                    Option(value="多余") 多余
                    Option(value="残缺") 残缺
                    Option(value="错误") 错误
            FormItem(label='原因说明' )
              textarea.explain(v-model='item.desc' placeholder="请说明原因" :maxlength="200")
            //- Checkbox(v-model="item.isAnswer") 参考答案
        FormItem(label='' :label-width="80")
          Button(type="primary" icon="md-add" ghost @click="handleAddQuestion") 添加问题
      FormItem(label='分值' :label-width="80")
        InputNumber(:max="100" :min="0" v-model="question.score")
</template>

<script>
import iTag from "@/components/common/iTag";
import iDelModel from "@/components/common/iDelModel";
import isEditTips from "@/components/common/iEditTips";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    iTag,
    iDelModel,
    isEditTips,
    quillEditor
  },
  props: ["data"],
  data() {
    return {
      editorOption: {
        placeholder: "请输入段落内容",
        modules: {
          toolbar: [
            [
              "bold",
              "italic",
              "underline",
              "strike",
              "image",
              "link",
              { indent: "-1" },
              { indent: "+1" },
              { align: "" },
              { align: "center" },
              { align: "right" },
              { color: [] },
              { background: [] },
              {
                font: [
                  "SimSun",
                  "SimHei",
                  "Microsoft-YaHei",
                  "KaiTi",
                  "FangSong",
                  "Arial",
                  "sans-serif"
                ]
              },
              { size: ["small", false, "large", "huge"] }
            ]
          ]
        }
      },
      question: {
        stem: "",
        score: 0,
        extend: [{ title: "", editorContent: "", key: "z" }],
        metas: [
          {
            position: "",
            question: "",
            desc: "",
            isAnswer: false,
            key: "a"
          }
        ]
      },
      isEditTips: false
    };
  },
  methods: {
    handleAddPar() {
      if (this.question.extend.length === 10) {
        this.$Message.error("最多添加10条！");
        return;
      }
      const uniqueId = Date.now() + Math.random().toString(36).substring(2, 9);
      this.question.extend.push({
        title: "",
        editorContent: "",
        key: uniqueId.toString()
      });
    },
    handleAddQuestion() {
      if (this.question.metas.length === 10) {
        this.$Message.error("最多添加10条！");
        return;
      }
      const uniqueId = Date.now() + Math.random().toString(36).substring(2, 9);
      this.question.metas.push({
        position: "",
        question: "",
        desc: "",
        isAnswer: false,
        key: uniqueId.toString()
      });
    },
    handleDelQuestion(index) {
      this.question.metas = this.question.metas.filter((val, i) => i !== index);
    },
    handleDelPar(index) {
      this.question.extend = this.question.extend.filter((val, i) => i !== index);
    },
    editTips() {
      // 编辑提示
      this.isEditTips = !this.isEditTips;
    },
    // 删除
    delModel() {
      this.$emit("delModel");
    },
    // 复选框状态
    changebox() {
      this.question.score = 0;
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (Object.keys(this.data).length !== 0) {
        this.question = this.data;
      }
      //   this.$emit("data1:data", this.question);
    });
  },
  watch: {
    question: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.data)) {
          this.$emit("data1:data", val);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    data: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") this.question = val; // 更新本地变量
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
<style lang="stylus">
.steminp
  margin 0
  .ivu-input-default
    margin 0!important
.fillblank
  width 790px
  padding 24px 16px 24px 44px
  .question-stem
    position relative
    .ivu-form-item-content
      width 75%
  .checkbox
    width 100%
    height 50px
    padding-left 85px
  .explain
    width 100%
    height 100px
    background rgba(255, 255, 255, 1)
    border-radius 4px
    border 1px solid rgba(210, 221, 236, 1)
    resize none
    outline none
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 0.75)
    line-height 18px
    padding 5px
</style>
